import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';

import css from './JobsPage.module.css';
import { NamedLink } from '../../components';

const JobsList = () => {
  
  return (
    <div className={css.vacanciesContainer}>
      <div className={css.vacanciesList}>
        <div className={classNames(css.vacancyItem, css.vacancyItemYellow)}>
          <NamedLink name="JobsPageVacancy3">
            <h4 className={css.vacancyTitle}>
            Part-time Teacher Content Curator
            </h4>
            <div className={css.vacancyInfo}>
            <ul>
              <li>Part-time</li>
              <li>$13.00 - $19.00 per hour</li>
              <li>Flexible schedule</li>
              <li>Work from home</li>
              </ul>
            </div>
          </NamedLink>
        </div>
        <div className={classNames(css.vacancyItem, css.vacancyItemBlue)}>
          <NamedLink name="JobsPageVacancy1">
            <h4 className={css.vacancyTitle}>Florida Lead Teacher / State Manager</h4>
            <div className={css.vacancyInfo}>
              <ul>
                <li>Part-time or Temporary</li>
                <li>$20.00 - $40.00 per hour</li>
                <li>Flexible schedule</li>
                <li>Bonus pay</li>
                <li>Work from home</li>
              </ul>
            </div>
          </NamedLink>
        </div>
        <div className={classNames(css.vacancyItem, css.vacancyItemRed)}>
          <NamedLink name="JobsPageVacancy2">
            <h4 className={css.vacancyTitle}>Texas Lead Teacher / State Manager</h4>
            <div className={css.vacancyInfo}>
              <ul>
                <li>Part-time or Temporary</li>
                <li>$20.00 - $40.00 per hour</li>
                <li>Flexible schedule</li>
                <li>Bonus pay</li>
                <li>Work from home</li>
              </ul>
            </div>
          </NamedLink>
        </div>
        <div className={classNames(css.vacancyItem, css.vacancyItemPink)}>
          <NamedLink name="JobsPageVacancy4">
            <h4 className={css.vacancyTitle}>Georgia Lead Teacher / State Manager</h4>
            <div className={css.vacancyInfo}>
              <ul>
                <li>Part-time or Temporary</li>
                <li>$20.00 - $40.00 per hour</li>
                <li>Flexible schedule</li>
                <li>Bonus pay</li>
                <li>Work from home</li>
              </ul>
            </div>
          </NamedLink>
        </div>
      </div>
    </div>
  )
}

export default JobsList;